/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ToggleAllAction/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function ToggleAllAction({
  children,
  viewPath = "/App/Account/Content/Settings/Content/NoteTemplates/Templates/Content/Content/ToggleAllAction"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let noteTemplatesTabNoteTemplatesLengthValueData = fromData.useDataValue({ viewPath,
context: 'note_templates_tab',
path: 'note_templates.length',
})
let noteTemplatesLengthValueData = fromData.useDataValue({ viewPath,
context: 'note_templates',
path: 'length',
})
let aggregateData = fromAggregate.equals(noteTemplatesTabNoteTemplatesLengthValueData, noteTemplatesLengthValueData)
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 marginLeft={dtSpaceXs}
 size="small"
 type="secondary"
 onClick={onClick}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text={aggregateData ? "Unselect all" : "Select all"}
 data="note_templates_tab.note_templates.length"
 data="note_templates.length"
 aggregate="/Simple/Data/aggregate.js equals"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}